module.exports = __webpack_public_path__ + "media/images/flowbite_user-settings-solid-6705762d6443e8b8c5e36358766e1b03.png";